/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable jsx-a11y/label-has-associated-control */

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable import/no-cycle */
import { Icon } from '@chakra-ui/icons';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Button,
  Flex,
  Heading,
  Tag,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import { useCallback } from 'react';
import {
  Control,
  FormState,
  UseFormGetFieldState,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormUnregister,
  useFieldArray,
} from 'react-hook-form';
import { FiInfo } from 'react-icons/fi';

import { useUserContext } from '../../core/context/user.context';
import useFetch from '../../core/hooks/useFetch';
import ArrayItem from './ArrayItem';

interface IProps {
  control: Control<any, any>;
  register: UseFormRegister<any>;
  unregister: UseFormUnregister<any>;
  field: any;
  getFieldState: UseFormGetFieldState<any>;
  getValues: UseFormGetValues<any>;
  formState: FormState<any>;
  setValue: UseFormSetValue<any>;
  path?: string;
  trigger: any;
}

const BASE_URL = `${process.env.REACT_APP_API_URL}`;

export default function ArrayField({
  control,
  register,
  unregister,
  field,
  getFieldState,
  getValues,
  formState,
  setValue,
  path = '',
  trigger,
}: IProps) {
  const { fields, append, remove, move, insert } = useFieldArray({
    control,
    name: `${path}${field.name}`,
    keyName: 'customID',
  });
  const { doFetch } = useFetch(`${BASE_URL}${field?.addAllPath}`);
  const { token } = useUserContext();
  const toast = useToast();

  const addAll = useCallback(async () => {
    const alreadyHasElements = getValues(`${path}.${field.name}`).length > 0;
    if (!alreadyHasElements) {
      const result = await doFetch({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if ('data' in result) {
        if ('items' in result.data && result.data.items.length > 0) {
          const arr = result.data.items.map((item: any) => ({
            journey: {
              journey: item.slug,
              pg_modules: item.pg_modules,
            },
          }));
          append(arr);
        }
      }
    } else {
      toast({
        title: `Can't add all ${field.label.toLowerCase()} when there is already an element`,
        status: 'error',
        position: 'top',
      });
    }
  }, []);

  if (field.condition && field.conditionValues) {
    if (!field.conditionValues.includes(getValues(`${path}${field.condition}`))) {
      const values = getValues((path.length > 0 ? path : undefined) as any) || {};
      if (Object.keys(values).length > 0) {
        delete values[field.name];
      }

      return null;
    }
  }

  return (
    <Accordion
      allowToggle
      _notLast={{
        mb: 5,
      }}
    >
      <AccordionItem boxShadow="0 0 8px rgba(0,0,0,0.2)" borderRadius={6} p={2}>
        <AccordionButton borderRadius={6}>
          <Heading fontSize={24} display="flex" alignItems="center">
            {field.label}{' '}
            <Tag ml={5} fontWeight="bold">
              {fields.length}
            </Tag>
            {!field.info ? null : (
              <Tooltip label={field.info} hasArrow p={5} borderRadius={5}>
                <Tag mx={3} p={1}>
                  <Icon fontSize={15} as={FiInfo} />
                </Tag>
              </Tooltip>
            )}
          </Heading>
          <AccordionIcon ml="auto" />
        </AccordionButton>
        <AccordionPanel mt={5}>
          <ul>
            {fields.map((item: any, index) => (
              <ArrayItem
                item={item}
                index={index}
                key={item.customID}
                {...{
                  control,
                  register,
                  unregister,
                  formState,
                  field,
                  getFieldState,
                  getValues,
                  setValue,
                  path: `${path}${field.name}`,
                  trigger,
                  fields,
                  remove,
                  move,
                  insert,
                }}
              />
            ))}
          </ul>
          {fields.length >= field.maxLength ? null : (
            <Flex gap={2}>
              <Button
                colorScheme="messenger"
                type="button"
                shadow="lg"
                mt={5}
                onClick={() => {
                  append(field?.allowRawString ? '' : {});
                }}
              >
                Add {field.label}
              </Button>
              {field.addAllBtn && (
                <Button colorScheme="messenger" type="button" shadow="lg" mt={5} onClick={addAll}>
                  Add All {field.label}
                </Button>
              )}
            </Flex>
          )}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
